import { EAssetSiteA11yStatus, EBackhaulA11yStatus, EPowerSupplyA11yStatus } from '@enums/map';

import colors from '@constants/colors';

export const addTooltipText = 'Add a new asset';
export const searchTooltipText = 'Search by ID or address';
export const removeTooltipText = 'Delete this asset';
export const removeTooltipTextRented = 'The asset can’t be deleted as it’s been rented by MNOs';
export const viewAssetCardTooltipText = 'View asset card';
export const viewTooltipText = 'View profile';
export const profilePath = `asset-profile`;
export const importTooltipText = 'Import assets';
export const accessAvailabilityOptions = [
	{
		label: 'Yes',
		value: true,
	},
	{
		label: 'No',
		value: false,
	},
];

export const getColorsOptions = (
	enumsType: typeof EBackhaulA11yStatus | typeof EPowerSupplyA11yStatus | typeof EAssetSiteA11yStatus,
) => ([
	{
		label: ' Distance >15m',
		value: enumsType.red,
		color: colors.pink50,
		hoverColor: colors.pink20,
	},
	{
		label: 'Distance 5m-15m',
		value: enumsType.amber,
		color: colors.orange50,
		hoverColor: colors.orange20,
	},
	{
		label: 'Distance <5m',
		value: enumsType.green,
		color: colors.green60,
		hoverColor: colors.green20,
	},
]);

export const noSubTypeOptions = {
	value: 'NO_SUBTYPE',
	label: 'No subtype',
};
